import { useSettings } from 'connectors/Settings/Settings';
import { useMemo } from 'react';
import { SelectOptionType } from 'types/selectOptions';

export const useDistrictsAsSelectOptions = (): SelectOptionType[] => {
    const districts = useSettings()?.districts;

    return useMemo(
        () => districts?.map(({ code, name }) => ({ value: code, label: `${name} (${code})` })) ?? [],
        [districts],
    );
};
